var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "factor-base-reveal-network" }, [
    _vm.legendItems.length
      ? _c(
          "div",
          { staticClass: "network-legend mb-2" },
          _vm._l(_vm.legendItems, function (item, i) {
            return _c(
              "span",
              {
                key: i,
                staticClass: "legend-item",
                style: { borderLeftColor: item.color },
              },
              [_vm._v(" " + _vm._s(item.label) + " ")]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "network-wrapper" }, [
      _c("div", {
        ref: "container",
        staticClass: "network-container",
        style: { height: _vm.height + "px" },
      }),
      _vm.visNetwork
        ? _c(
            "div",
            { staticClass: "zoom-slider-outer" },
            [
              _c("div", { staticClass: "zoom-slider-block" }, [
                _c("label", { staticClass: "zoom-slider-label" }, [
                  _vm._v("Zoom"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.zoomLevel,
                      expression: "zoomLevel",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "zoom-slider",
                  attrs: {
                    type: "range",
                    min: _vm.zoomMin,
                    max: _vm.zoomMax,
                    step: _vm.zoomStep,
                  },
                  domProps: { value: _vm.zoomLevel },
                  on: {
                    input: _vm.applyZoom,
                    __r: function ($event) {
                      _vm.zoomLevel = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _vm.showPopupButton
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "zoom-slider-divider",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("|")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-secondary network-popup-btn",
                        attrs: {
                          type: "button",
                          "aria-label": "Open in larger view",
                          title: "Open in larger view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("open-popup")
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "fullscreen" } })],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }